(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cactus-gifts"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cactus-gifts]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='1';
  root.addEventListener('click',async event=>{
    const view=event.target.closest('[data-view-set]');if(view){root.querySelector('[data-set-dialog="'+view.dataset.viewSet+'"]')?.showModal();return}
    const close=event.target.closest('[data-close-set]');if(close){close.closest('dialog')?.close();return}
    const add=event.target.closest('[data-add-curated]');if(!add)return;
    const dialog=add.closest('dialog'),status=dialog.querySelector('[data-status]');let items=JSON.parse(dialog.querySelector('[data-set-items]').textContent||'[]');if(items.some(i=>!i.id)){status.textContent='A product in this set is unavailable.';return}
    add.disabled=true;status.textContent='Adding your set…';
    try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});const result=await response.json();if(!response.ok)throw Error(result.description||result.message||'Could not add set');status.textContent='Set added to cart';dialog.close();const drawer=document.querySelector('cart-drawer');if(drawer?.renderContents&&result.sections?.['cart-drawer']){drawer.renderContents(result);drawer.open()}else location.assign((window.Shopify?.routes?.root||'/')+'cart')}
    catch(error){status.textContent=error.message}finally{add.disabled=false}
  });
  root.querySelectorAll('[data-set-dialog]').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()}));
  const requested=new URLSearchParams(location.search).get('set');if(['full','gift'].includes(requested))root.querySelector('[data-set-dialog="'+requested+'"]')?.showModal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cactus-product]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const currency = root.dataset.currency || 'AUD';
    const money = (cents) => new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    const renderCart = (result) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
        drawer.renderContents(result);
        if (typeof drawer.open === 'function') drawer.open();
        return true;
      }
      return false;
    };

    root.querySelectorAll('[data-media-trigger]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-id]').forEach((item) => { item.hidden = item.dataset.mediaId !== button.dataset.mediaTrigger; item.classList.toggle('is-active', !item.hidden); });
      root.querySelectorAll('[data-media-trigger]').forEach((thumb) => { const active = thumb === button; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-selected', String(active)); });
    }));

    const mobileBar = root.querySelector('[data-mobile-atc]');
    const purchaseForm = root.querySelector('[data-single-form]');
    mobileBar?.querySelector('button')?.addEventListener('click', () => purchaseForm?.requestSubmit());
    if (mobileBar && purchaseForm && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        mobileBar.hidden = entry.boundingClientRect.bottom > 0 || entry.isIntersecting || purchaseForm.querySelector('[data-single-submit]')?.disabled || window.matchMedia('(min-width: 750px)').matches || document.querySelector('cart-drawer.active');
      }, { threshold: 0 });
      observer.observe(purchaseForm);
    }
    const addCompanions = async (items, button) => {
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product.');
        if (!renderCart(result)) window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        const status = root.querySelector('[data-single-status]');
        if (!status) return;
        status.textContent = error.message;
        status.classList.add('is-error');
      } finally { button.disabled = false; }
    };
    root.querySelectorAll('[data-companion-add]').forEach(button => button.addEventListener('click', () => addCompanions([{id:button.dataset.companionAdd,quantity:1}],button)));
    root.querySelector('[data-routine-add]')?.addEventListener('click', event => {
      const items = JSON.parse(root.querySelector('[data-routine-items]').textContent);
      if (items.length) addCompanions(items,event.currentTarget);
    });
    const qty = root.querySelector('[data-qty]');
    const updateSinglePrice = () => {
      if (!qty || !root.querySelector('[data-single-price]')) return;
      const quantity = Math.max(1, parseInt(qty?.value, 10) || 1);
      if (qty) qty.value = quantity;
      const selectedOption = root.querySelector('[data-variant-select]')?.selectedOptions[0];
      const unitPrice = Number(selectedOption?.dataset.priceCents || root.dataset.currentPrice || 0);
      const subtotal = unitPrice * quantity;
      root.querySelector('[data-single-price]').textContent = `— ${money(subtotal)}`;
    };
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); updateSinglePrice(); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) + 1); updateSinglePrice(); });
    qty?.addEventListener('change', updateSinglePrice);

    root.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      root.querySelector('[data-variant-id]').value = option.value;
      root.querySelector('[data-product-price]').textContent = option.dataset.price;
      if (mobileBar) mobileBar.querySelector('[data-sticky-price]').textContent = option.dataset.price;
      if (mobileBar) mobileBar.querySelector('button').disabled = option.disabled;
      root.dataset.currentPrice = option.dataset.priceCents;
      updateSinglePrice();
    });

    root.querySelector('[data-single-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const button = root.querySelector('[data-single-submit]');
      const status = root.querySelector('[data-single-status]');
      button.disabled = true;
      status.textContent = '';
      status.classList.remove('is-error');
      const data = new FormData(form);
      data.set('quantity', String(Math.max(1, parseInt(qty?.value, 10) || 1)));
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', window.location.pathname);
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product.');
        status.textContent = 'Added to cart.';
        if (!renderCart(result)) window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (error) {
        status.textContent = error.message;
        status.classList.add('is-error');
      } finally { button.disabled = false; }
    });
    updateSinglePrice();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-reference-header"]) return;
  try {
    
  document.querySelectorAll('.cr-menu').forEach(menu => {
    menu.querySelector('[data-cr-close]').addEventListener('click', () => { menu.open = false; menu.querySelector('summary').focus(); });
    menu.addEventListener('keydown', event => { if(event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-reference-home"] && !Shopify.designMode) return;
  try {
    
 document.querySelectorAll('.cr-home').forEach(home => {
   const rail = home.querySelector('[data-cr-rail]');
   home.querySelector('[data-cr-next]').addEventListener('click', () => rail.scrollBy({left:rail.clientWidth * .85,behavior:'smooth'}));
   home.querySelector('[data-cr-previous]').addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth * .85,behavior:'smooth'}));
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-scent-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-cactus-scent-finder]').forEach((finder) => {
    if (finder.dataset.ready) return;
    finder.dataset.ready = '1';

    const mode = finder.dataset.mode;
    const submit = finder.querySelector('[data-cactus-scent-submit]');
    const reset = finder.querySelector('[data-cactus-scent-reset]');
    const result = finder.querySelector('[data-cactus-scent-result]');
    const count = finder.querySelector('[data-cactus-mobile-count]');
    const back = finder.querySelector('[data-cactus-mobile-back]');
    const galleryCards = [...finder.querySelectorAll('[data-cactus-gallery-card]')];
    const steps = [...finder.querySelectorAll('[data-cactus-step]')];
    let started = false;
    let mobileStep = 1;
    const scents = {
      'fresh-botanical-easy': ['Eucalyptus Marine', 'eucalyptus-marine', 'Airy eucalyptus, aquatic freshness and an earthy finish.', 'Cedar Botanical', 'cedar-botanical'],
      'fresh-botanical-deep': ['Cedar Botanical', 'cedar-botanical', 'Green herbs, citrus and frankincense over a woody, resinous base.', 'Lavender Nocturne', 'lavender-nocturne'],
      'fresh-smooth-easy': ['Wild Pear', 'wild-pear', 'Juicy pear and citrus with florals, soft woods and a little spice.', 'Lavender Nocturne', 'lavender-nocturne'],
      'fresh-smooth-deep': ['Lavender Nocturne', 'lavender-nocturne', 'Bright citrus and herbs with Australian lavender, chamomile and vetiver.', 'Wild Pear', 'wild-pear'],
      'warm-botanical-easy': ['Sandalwood & Chamomile', 'sandalwood-chamomile', 'Warm sandalwood, tea, herbs and soft florals. Easy-going, with plenty going on.', 'Cedar Botanical', 'cedar-botanical'],
      'warm-botanical-deep': ['Cedar Botanical', 'cedar-botanical', 'Woody, green and resinous—more scenic route than straight line.', 'Sandalwood & Chamomile', 'sandalwood-chamomile'],
      'warm-smooth-easy': ['Sandalwood & Chamomile', 'sandalwood-chamomile', 'Rounded woods, chamomile and soft musk without making a huge fuss.', 'Dark Vanilla', 'dark-vanilla'],
      'warm-smooth-deep': ['Dark Vanilla', 'dark-vanilla', 'Bourbon vanilla, amber, patchouli and spice. After-dark in the good way.', 'Sandalwood & Chamomile', 'sandalwood-chamomile']
    };
    const productData = finder.querySelector('[data-cactus-scent-products]');
    let products = {};
    try {
      products = JSON.parse(productData.textContent);
    } catch (error) {
      return;
    }

    const checked = (name) => finder.querySelector('input[name^="' + name + '"]:checked');
    const isMobile = () => mode === 'compact' && window.matchMedia('(max-width: 749px)').matches;
    const updateSubmit = () => {
      submit.disabled = !checked('cactus-temperature') || !checked('cactus-style') || !checked('cactus-depth');
      submit.setAttribute('aria-disabled', String(submit.disabled));
    };
    const setStep = (step) => {
      mobileStep = Math.max(1, Math.min(3, step));
      steps.forEach((field, index) => field.classList.toggle('is-active', index + 1 === mobileStep));
      if (count) count.textContent = mobileStep + ' OF 3';
      if (back) back.hidden = mobileStep === 1;
    };
    const track = (eventName, detail) => document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
    const bindResultLinks = (scent, product) => {
      result.querySelectorAll('[data-result-link]').forEach((link) => {
        link.addEventListener('click', () => track('cactus_scent_finder_result_clicked', {
          primary: scent[1],
          secondary: scent[4],
          context: mode === 'compact' ? 'homepage' : mode,
          destination: product.url,
          action: link.dataset.action
        }), { once: true });
      });
    };

    if (mode === 'compact') {
      setStep(1);
      window.addEventListener('resize', () => {
        if (!isMobile()) steps.forEach((field) => field.classList.remove('is-active'));
        else setStep(mobileStep);
      });
    }

    const clearGalleryMatch = () => galleryCards.forEach((card) => card.classList.remove('is-match'));
    const clearCompactResult = () => {
      if (mode !== 'compact' || !finder.classList.contains('has-compact-result')) return false;
      clearGalleryMatch();
      finder.classList.remove('has-compact-result');
      result.classList.add('is-leaving');
      if (isMobile()) setStep(1);
      window.setTimeout(() => {
        if (!finder.classList.contains('has-compact-result')) {
          result.className = 'cactus-finder__result';
          result.innerHTML = '';
        }
      }, 160);
      return true;
    };

    finder.addEventListener('change', (event) => {
      const resultWasVisible = clearCompactResult();
      updateSubmit();
      if (!started) {
        track('cactus_scent_finder_started', { context: mode });
        started = true;
      }
      if (isMobile()) {
        const step = Number(event.target.closest('[data-cactus-step]')?.dataset.cactusStep);
        if (step && step < 3 && mobileStep === step) window.setTimeout(() => setStep(step + 1), 260);
      }
    });

    back?.addEventListener('click', () => setStep(mobileStep - 1));

    submit.addEventListener('click', () => {
      if (submit.disabled) return;
      const key = [checked('cactus-temperature').value, checked('cactus-style').value, checked('cactus-depth').value].join('-');
      const scent = scents[key];
      if (!scent) return;
      const product = products[scent[1]];
      const alternate = products[scent[4]];
      if (!product || !alternate) return;

      if (mode === 'compact') {
        clearGalleryMatch();
        galleryCards.forEach((card) => card.classList.toggle('is-match', card.dataset.scentHandle === scent[1]));
        finder.classList.add('has-compact-result');
        if (isMobile()) {
          finder.querySelectorAll('input').forEach((input) => input.checked = false);
          updateSubmit();
          setStep(1);
        }
        result.className = 'cactus-finder__result is-ready';
        result.innerHTML = '<div class="cactus-ticket__stub"><img src="' + product.image + '" alt="' + product.title + '"></div><div class="cactus-ticket__copy"><p>YOUR CACTUS IS…</p><h2>' + scent[0] + '</h2><div class="detail">' + scent[2] + '</div><span>WILDER DAYS</span><button type="button" data-cactus-scent-reset-inline>TRY AGAIN ↻</button></div><div class="cactus-ticket__action"><div class="cactus-ticket__stamp" aria-hidden="true">CACTUS<small>SCENT ROUTE</small></div><a href="' + product.url + '" data-result-link data-action="product">SHOP ' + scent[0].toUpperCase() + ' →</a></div>';
        result.querySelector('[data-cactus-scent-reset-inline]').addEventListener('click', () => reset.click());
        track('cactus_scent_finder_completed', { primary: scent[1], secondary: scent[4], context: 'homepage' });
        bindResultLinks(scent, product);
        return;
      }

      result.classList.add('is-ready');
      result.innerHTML = '<img src="' + product.image + '" alt="' + product.title + '"><div><p>YOUR CACTUS IS…</p><h2>' + scent[0] + '</h2><div class="detail">' + scent[2] + '</div><strong>50 G · ' + product.price + '</strong><br><button type="button" data-cactus-result-add data-variant="' + product.variant + '">ADD TO CART</button><a href="' + product.url + '" data-result-link data-action="view">SHOP ' + scent[0].toUpperCase() + ' →</a><a class="secondary" href="' + alternate.url + '" data-result-link data-action="alternate">ALSO TRY ' + scent[3].toUpperCase() + ' →</a><a class="secondary" href="/pages/build-your-own-set?set=' + scent[1] + '-' + scent[4] + '" data-result-link data-action="builder">BUILD A SET WITH BOTH →</a></div>';
      reset.hidden = false;
      track('cactus_scent_finder_completed', { primary: scent[1], secondary: scent[4], context: mode });
      result.querySelector('[data-cactus-result-add]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        button.disabled = true;
        button.textContent = 'ADDING…';
        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.variant), quantity: 1 }] }) });
          if (!response.ok) throw new Error();
          button.textContent = 'ADDED';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          button.disabled = false;
          button.textContent = 'TRY AGAIN';
        }
      });
      bindResultLinks(scent, product);
    });

    reset.addEventListener('click', () => {
      finder.querySelectorAll('input').forEach((input) => input.checked = false);
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      reset.hidden = true;
      finder.classList.remove('has-compact-result');
      clearGalleryMatch();
      result.className = 'cactus-finder__result';
      result.innerHTML = mode === 'full' ? '<p>YOUR CACTUS IS…</p><span>Answer three very serious questions about your underarms.</span>' : '';
      started = false;
      if (mode === 'compact') setStep(1);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-set-builder-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cactus-set]').forEach((root)=>{
  if(root.dataset.ready)return;root.dataset.ready='1';
  const products=JSON.parse(root.querySelector('[data-products]').textContent||'[]');
  const byHandle=new Map(products.map(p=>[p.handle,p]));const scentChoices=products.filter(p=>!p.handle.includes('eau-de-parfum')&&!p.handle.includes('scrub-bar'));const lines=new Map();
  const curatedSets={
    full:['cedar-botanical','eucalyptus-marine','lavender-nocturne','sandalwood-chamomile','dark-vanilla','wild-pear','dark-vanilla-eau-de-parfum-10ml','cedar-botanical-scrub-bar'],
    gift:['cedar-botanical','eucalyptus-marine','dark-vanilla-eau-de-parfum-10ml','cedar-botanical-scrub-bar'],
    explorer:['cedar-botanical','eucalyptus-marine','lavender-nocturne','dark-vanilla-eau-de-parfum-10ml'],
    'dark-vanilla-pair':['dark-vanilla','dark-vanilla-eau-de-parfum-10ml'],
    pair:['cedar-botanical','eucalyptus-marine'],
    rotation:['cedar-botanical','eucalyptus-marine','lavender-nocturne']
  };
  const params=new URLSearchParams(window.location.search);const requestedSet=params.get('set');
  const requestedScents=(params.get('scents')||'').split(',').filter(h=>scentChoices.some(p=>p.handle===h));requestedScents.forEach(h=>lines.set(h,1));
  if(requestedSet&&curatedSets[requestedSet])curatedSets[requestedSet].forEach(handle=>{if(byHandle.has(handle))lines.set(handle,(lines.get(handle)||0)+1)});
  const requestedAdd=new URLSearchParams(window.location.search).get('add')||window.sessionStorage.getItem('cactus-pending-add');
  if(requestedAdd&&byHandle.has(requestedAdd)){if(requestedAdd==='cedar-botanical-scrub-bar'&&!lines.size){lines.set('cedar-botanical',1);lines.set('dark-vanilla-eau-de-parfum-10ml',1);}lines.set(requestedAdd,(lines.get(requestedAdd)||0)+1);window.sessionStorage.removeItem('cactus-pending-add');}
  const money=cents=>new Intl.NumberFormat('en-AU',{style:'currency',currency:root.dataset.currency||'AUD'}).format(cents/100);
  root.querySelectorAll('[data-add-scent]').forEach(select=>{scentChoices.forEach(choice=>{const option=document.createElement('option');option.value=choice.handle;option.textContent=choice.title;select.append(option)})});
  const summary=root.querySelector('[data-summary]'),overlay=root.querySelector('[data-overlay]');
  const mobile=window.matchMedia('(max-width:749px)');
  const open=()=>{if(!mobile.matches)return;summary.classList.add('is-open');summary.setAttribute('role','dialog');summary.setAttribute('aria-modal','true');overlay.hidden=false;document.body.classList.add('overflow-hidden');summary.querySelector('[data-close-summary]').focus()};
  const close=()=>{const wasOpen=summary.classList.contains('is-open');summary.classList.remove('is-open');summary.removeAttribute('role');summary.removeAttribute('aria-modal');overlay.hidden=true;if(!document.querySelector('cart-drawer.active'))document.body.classList.remove('overflow-hidden');if(wasOpen)root.querySelector('[data-view-summary]').focus()};
  root.querySelectorAll('[data-view-summary]').forEach(button=>button.addEventListener('click',open));
  root.querySelector('[data-close-summary]').addEventListener('click',close);
  root.querySelector('[data-change-scents]').addEventListener('click',()=>{close();root.querySelector('.cactus-set__shop').scrollIntoView({behavior:'smooth',block:'start'})});
  overlay.addEventListener('click',close);mobile.addEventListener('change',()=>{if(!mobile.matches)close()});
  summary.addEventListener('keydown',event=>{if(!summary.classList.contains('is-open'))return;if(event.key==='Escape'){close();return}if(event.key!=='Tab')return;const buttons=[...summary.querySelectorAll('button,select,a,input')].filter(button=>button.getClientRects().length&&!button.disabled);if(!buttons.length)return;const first=buttons[0],last=buttons[buttons.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}});
  const render=()=>{
    const holder=root.querySelector('[data-lines]');holder.replaceChildren();
    const count=[...lines.values()].reduce((sum,quantity)=>sum+quantity,0);let total=0;
    for(const [handle,quantity] of lines){const p=byHandle.get(handle);if(!p)continue;total+=p.price*quantity;
      const row=document.createElement('div');row.className='cactus-set__line';
      const img=document.createElement('img');img.src=p.image||'';img.alt='';row.append(img);
      const content=document.createElement('div');const title=document.createElement('strong');title.textContent=p.title;const price=document.createElement('small');price.textContent=money(p.price*quantity);
      const controls=document.createElement('div');controls.className='cactus-set__stepper';
      for(const [label,action,name] of [['−','minus','Decrease quantity'],[String(quantity),'none','Quantity'],['+','plus','Increase quantity'],['Remove','remove','Remove product']]){
        if(action==='none'){const span=document.createElement('span');span.textContent=label;controls.append(span);continue}
        const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset[action]=handle;button.setAttribute('aria-label',name+' of '+p.title);if(action==='plus'&&count>=9)button.disabled=true;controls.append(button)
      }
      if(scentChoices.some(choice=>choice.handle===handle)){const swapLabel=document.createElement('label');swapLabel.className='cactus-set__swap-label';swapLabel.textContent='SWAP SCENT';const swap=document.createElement('select');swap.dataset.swapScent=handle;swap.setAttribute('aria-label','Swap '+p.title+' for another deodorant scent');scentChoices.forEach(choice=>{const option=document.createElement('option');option.value=choice.handle;option.textContent=choice.title;if(choice.handle===handle)option.selected=true;swap.append(option)});swapLabel.append(swap);content.append(swapLabel)}content.append(title,price,controls);row.append(content);holder.append(row)
    }
    root.querySelector('[data-empty]').hidden=count>0;root.querySelector('[data-edit-note]').hidden=count===0;root.querySelector('[data-progress]').hidden=count===0;root.querySelector('[data-progress-count]').textContent=count;
    root.querySelector('[data-count]').textContent=count;root.querySelector('[data-mobile-count]').textContent=count;
    const deodorantQuantity=[...lines].reduce((sum,[handle,quantity])=>sum+(scentChoices.some(choice=>choice.handle===handle)?quantity:0),0);const discount=deodorantQuantity>=3&&deodorantQuantity<=6?(deodorantQuantity-2)*500:0;const setTotal=total-discount;
    root.querySelector('[data-subtotal]').textContent=money(total);root.querySelector('[data-discount]').textContent='−'+money(discount);root.querySelector('[data-discount-row]').hidden=!discount;root.querySelector('[data-total]').textContent=money(setTotal);root.querySelector('[data-mobile-total]').textContent=money(setTotal);
    root.querySelector('[data-shipping]').textContent=setTotal>=10000?'FREE SHIPPING UNLOCKED':money(10000-setTotal)+' away from free standard shipping';
    root.querySelectorAll('[data-add-product]').forEach(button=>{const selected=lines.has(button.dataset.addProduct);button.disabled=count>=9||!byHandle.has(button.dataset.addProduct);button.textContent=selected?'ADD ANOTHER +':'ADD TO SET +' });
    const soapWithoutDeo=lines.has('cedar-botanical-scrub-bar')&&!deodorantQuantity;const valid=count>=2&&count<=9&&!soapWithoutDeo;root.querySelector('[data-add-set]').disabled=!valid;
    root.querySelector('[data-set-status]').textContent=soapWithoutDeo?'Add a deodorant to include the scrub bar.':count===1?'Choose one more product to complete your set.':count>=9?'Set limit reached: 9 products.':'';
  };
  root.addEventListener('change',event=>{const swap=event.target.closest('[data-swap-scent]');if(!swap)return;const from=swap.dataset.swapScent,to=swap.value,quantity=lines.get(from)||0;if(from===to||!byHandle.has(to))return;lines.delete(from);lines.set(to,(lines.get(to)||0)+quantity);render()});
  root.addEventListener('click',event=>{
    const drawerAdd=event.target.closest('[data-add-scent-button]');if(drawerAdd){const handle=root.querySelector('[data-add-scent]').value;const count=[...lines.values()].reduce((sum,quantity)=>sum+quantity,0);if(handle&&count<9&&byHandle.has(handle)){lines.set(handle,(lines.get(handle)||0)+1);render()}return}
    const filter=event.target.closest('[data-filter]');if(filter){root.querySelectorAll('[data-filter]').forEach(btn=>{btn.classList.toggle('is-active',btn===filter);btn.setAttribute('aria-pressed',String(btn===filter))});root.querySelectorAll('[data-category]').forEach(card=>card.hidden=filter.dataset.filter!=='all'&&card.dataset.category!==filter.dataset.filter);return}
    const preset=event.target.closest('[data-preset]');if(preset){lines.clear();preset.dataset.preset.split(',').forEach(handle=>{if(byHandle.has(handle))lines.set(handle,(lines.get(handle)||0)+1)});render();if(mobile.matches)open();return}
    const add=event.target.closest('[data-add-product]');if(add){const handle=add.dataset.addProduct;const count=[...lines.values()].reduce((sum,quantity)=>sum+quantity,0);if(count<9&&byHandle.has(handle)){lines.set(handle,(lines.get(handle)||0)+1);render()}return}
    for(const action of ['plus','minus','remove']){const button=event.target.closest('[data-'+action+']');if(button){const handle=button.dataset[action];const n=lines.get(handle)||0;const count=[...lines.values()].reduce((sum,quantity)=>sum+quantity,0);if(action==='plus'&&count>=9)return;if(action==='remove'||(action==='minus'&&n<=1))lines.delete(handle);else lines.set(handle,n+(action==='plus'?1:-1));render();return}}
  });
  root.querySelector('[data-add-set]').addEventListener('click',async event=>{
    const button=event.currentTarget,status=root.querySelector('[data-set-status]');const count=[...lines.values()].reduce((sum,quantity)=>sum+quantity,0);const deodorantQuantity=[...lines].reduce((sum,[handle,quantity])=>sum+(scentChoices.some(choice=>choice.handle===handle)?quantity:0),0);const discountCode=deodorantQuantity>=3&&deodorantQuantity<=6?'CACTUS-DEO-'+deodorantQuantity:'';const bundleId='cactus-set-'+Date.now();const items=[...lines].map(([handle,quantity])=>({id:byHandle.get(handle)?.id,quantity,properties:{'_cactus_bundle':bundleId,'_cactus_set':'Mix your own'}})).filter(item=>item.id&&item.quantity>0);if(count<2||count>9||(lines.has('cedar-botanical-scrub-bar')&&!deodorantQuantity))return;
    button.disabled=true;status.textContent='Adding your set…';
    try{
      const rootUrl=window.Shopify?.routes?.root||'/';
      const response=await fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const result=await response.json();
      if(!response.ok)throw Error(result.description||result.message||'Could not add set');
      status.textContent='Added to your cart.';
      window.location.assign(rootUrl+'cart');
      return
    }
    catch(error){status.textContent=error.message}finally{button.disabled=false;render()}
  });
  render();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
